import "./App.css";
import "./input.css";
import UploadPortal from "./pages/fileUpload/uploadPortal";
import Login from "./pages/login/login";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/dicom", element: <UploadPortal /> },
  { path: "*", element: <Login /> }
]);
function App() {
  return <RouterProvider router={router} />;
}

export default App;
